import "./cart.css";
import { Minus, Plus, SaudiRiyal, Trash2 } from "lucide-react";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";

function ProductCartItem({
  productDetails,
  showDivider,
  quantity,
  setQuantity,
  getCartDetails,
  onDeleteClick,
  onItemTotalPriceChange,
}) {
  const unitPrice =
    productDetails.item_calculates.final_price / productDetails.quantity;

  const [totalPrice, setTotalPrice] = useState(unitPrice * quantity);

  useEffect(() => {
    setTotalPrice(unitPrice * quantity);
  }, [unitPrice, quantity]);


  
  useEffect(() => {
    onItemTotalPriceChange(productDetails.cart_item_id, totalPrice);
  }, [totalPrice]);

  const qtyAvailable =
    productDetails?.variation?.variation_location_details[0].qty_available;

  const incrementCount = () => {
    if (quantity < qtyAvailable) {
      setQuantity(quantity + 1);
    }
  };

  const decrementCount = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  // console.log(productDetails);

  return (
    <div>
      <div className="productDetails">
        <img
          src={productDetails.product.image}
          alt={productDetails.product.name}
        />
        <div className="product-content">
          <div className="header">
            <h3>{productDetails.product.name}</h3>

            <div className="container-trash-icon">
              <Trash2 onClick={onDeleteClick} style={{ color: "red" }} size={18}/>
            </div>
          </div>
          <div>
            <p style={{ margin: "5px 0" ,fontSize:"13px",fontWeight:"500",}}>
              {productDetails.variation.display_name}
            </p>
            {productDetails.modifier_sets.length > 0
              ? productDetails.modifier_sets.map((modifier) => {
                  return (
                    <div key={modifier.id} style={{ marginBottom: "8px" }}>
                      <p style={{ marginBottom: "0" ,fontSize:"12px",fontWeight:"500",}}>
                        <span>{modifier.product.name}:</span>{" "}
                        <span>
                          {modifier.variations?.map((v, index) => (
                            <span key={v.id}>
                              {v.display_name}
                              {index < modifier.variations.length - 1 && "، "}
                            </span>
                          ))}
                        </span>
                      </p>
                    </div>
                  );
                })
              : " "}
          </div>

          <div className="price">
            {totalPrice} <SaudiRiyal size={13} />
          </div>

          <div className="btns-container">
            <Button
              className="btn"
              onClick={incrementCount}
              disabled={quantity === qtyAvailable}
            >
              <Plus size={"15"} />
            </Button>
            <div className="quantity">{quantity}</div>
            <Button
              className="btn"
              onClick={decrementCount}
              disabled={quantity === 1}
            >
              <Minus size={"15"} />
            </Button>
          </div>

          {quantity === qtyAvailable && (
            <div style={{ color: "red", marginTop: "15px" }}>
              {qtyAvailable} عناصر متاحة
            </div>
          )}
        </div>
      </div>
      {showDivider && <hr />}
    </div>
  );
}

export default ProductCartItem;
